import React from "react";

export default function CustomButton({ title, type, className, onClick }) {
  return (
    <button onClick={onClick} className={className}>
      {title}
    </button>
  );
}
